import React from 'react';
import { Normal, H5 } from 'components/Core/Typography';

import { Container } from './styles';

const WebinarKeyTakeaways = ({ keyTakeaways, bottomSection }) => (
  <Container bottomSection={bottomSection}>
    <H5 className="webinar-key-takeaways--title">What you will learn:</H5>
    <ul>
      {keyTakeaways.map((takeaway, index) => (
        <li key={`webinar-takeaways-${index}`}>
          {' '}
          <p>{takeaway}</p>
        </li>
      ))}
    </ul>
  </Container>
);

export default WebinarKeyTakeaways;
